module.exports = __webpack_public_path__ + "static/media/Logo.024981db.svg";